import hoistNonReactStatics from 'hoist-non-react-statics';
import { isEmpty, get } from 'lodash';
import React, { useCallback } from 'react';
import SpinnerError from '../../../utils/SpinnerError';
import useFilterStore from '../hooks/useFilterStore';
const withFilterStore = (Component) => {
    const Hoc = ({ filterKey, onBeforeUpdate, onBeforeComplete, resetOnLogin, resetOnLoginKeys, ...props }) => {
        const { values, onChange, error, loading } = useFilterStore(filterKey, {
            defaultValues: props.values,
            initialChange: props.onChange,
            searchName: props.searchName,
            searchQuery: get(props, ['values', `${props.searchName}`]),
            onBeforeUpdate,
            onBeforeComplete,
            resetOnLogin,
            resetOnLoginKeys,
        });
        const _onChange = useCallback(values => {
            onChange(values);
            props.onChange && props.onChange(values);
        }, [props, onChange]);
        if (filterKey) {
            return (<SpinnerError error={error} firstLoading={loading && isEmpty(values)} inline={false} loading={loading}>
          <Component {...props} values={values} onChange={_onChange}/>
        </SpinnerError>);
        }
        return <Component {...props}/>;
    };
    Hoc.displayName = `withFilterStore(${Component.displayName || Component.name})`;
    Hoc.defaultProps = {
        ...Component.defaultProps,
    };
    return hoistNonReactStatics(Hoc, Component);
};
export default withFilterStore;
